module.exports = __webpack_public_path__ + "static/img/1-1.a34afa1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/eng/1-1.png
// module id = ef9+
// module chunks = 0